
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      paddingLeft:90
    },

    tblContainer: {
      // maxHeight:'375px',
  },
  tblHeader:{
      "& th": {
          //  backgroundColor:'#fbfbfb',
          backgroundColor:'#4f4f50',
          color: '#fff',
          textTransform:'uppercase',
          fontSize:'12px',
          padding:'10px 5px !important',
      },

  },
  tblBody:{
      "& th": {
          backgroundColor:'#fff',
          color: '#000',
          textTransform:'uppercase',
          fontSize:'12px',
          padding:'6px 5px !important',
      },
      "& td": {
          color: '#000',
          backgroundColor: '#fff;',
          fontSize: '12px',
          textAlign: 'left',
          padding:'6px 5px !important',
          textTransform: 'uppercase',
          borderBottom:'1px solid #f5f7ff !important',
      },
  },

  
    content: {
        flexGrow: 1,
        // padding: theme.spacing(3),
        padding:'25px 15px 24px 90px',
      },
    toolbar: theme.mixins.toolbar,
}));

export default useStyles;